import { DefaultService } from '@/services/DefaultService';

export default class AlertaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    find (idempresa) {
        return this._http.get(`${this._env}/sales/emailconfig/${idempresa}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save (alerta) {
        return this._http.post(`${this._env}/sales/emailconfig`, alerta, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}